import { combineReducers } from 'redux'
import { IModuleDefinition } from '../../types'
import Accounts, {
  accountsModuleReducer,
  accountsModuleSagas
} from './Accounts'
import AI, { aiModuleReducer, aiModuleSagas } from './AI'
import BDA, { bdaReducer, bdaSagas } from './BDA'
import Clients, { clientsModuleReducer, clientsModuleSagas } from './Clients'
import Dashboard, { dashboardReducer, dashboardSagas } from './Dashboard'
import {
  dashboardFeaturesReducer,
  dashboardFeaturesSagas
} from './Dashboard/features'
import HomeOffice, {
  homeOfficeModuleReducer,
  homeOfficeModuleSagas
} from './HomeOffice'
import Rdot360, { rdot360ModuleReducer } from './Rdot360'
import Reports, {
  advisoryReportsReducer,
  advisoryReportsSagas
} from './Reports'
import Requests from './Requests'
import Revenue, { revenueModuleReducer, revenueModuleSagas } from './Revenue'
import Teams, { teamsModuleReducer, teamsModuleSagas } from './Teams'

export default [
  AI,
  Dashboard,
  BDA,
  Reports,
  Clients,
  Revenue,
  Accounts,
  Requests,
  Teams,
  Rdot360,
  HomeOffice
] as IModuleDefinition[]

export const advisoryModulesReducer = combineReducers({
  dashboardFeatures: dashboardFeaturesReducer,
  dashboard: dashboardReducer,
  bda: bdaReducer,
  reports: advisoryReportsReducer,
  clients: clientsModuleReducer,
  revenue: revenueModuleReducer,
  accounts: accountsModuleReducer,
  teams: teamsModuleReducer,
  rdot360: rdot360ModuleReducer,
  ai: aiModuleReducer,
  homeOffice: homeOfficeModuleReducer
})

export const advisoryModulesSagas = [
  ...dashboardFeaturesSagas,
  ...dashboardSagas,
  ...bdaSagas,
  ...advisoryReportsSagas,
  ...clientsModuleSagas,
  ...revenueModuleSagas,
  ...accountsModuleSagas,
  ...teamsModuleSagas,
  ...aiModuleSagas,
  ...homeOfficeModuleSagas
]
